import React, { useEffect,useContext,useState} from "react";
import Context from '../context/context';
import PhotoItem from './photoItem';
import Lang from '../lang/translations';
import Spinner from '../spinner/spinner';
import helpers from '../_helpers/helpersFunction'
import { useNavigate  } from "react-router-dom";


export default function Find(user) {
   
    const  context = useContext(Context)
    let navigate = useNavigate();

    async function showPopupHook(){
        
        helpers.kpiPanel(context, null, null, true, null, { canon:"search_filters_change", dedup:true})
        const cities = await helpers.getCitiesByCountry()
        helpers.showPopupgenerico("cambia_regione",context,cities)

	}


    
        useEffect(() => {
          document.body.classList.add("doi_confirm");
          return () => {
            document.body.classList.remove("doi_confirm");
          };
        }, []);

    
    var avaibleUsers = localStorage.getItem('avaibleUsers') ? localStorage.getItem('avaibleUsers') : false
    if(!avaibleUsers){
        avaibleUsers = helpers.randomNum(2100,3700)
        localStorage.setItem('avaibleUsers', avaibleUsers);
    }

	return ( <>
    { context.statoSignupForm ? ( <div className="container-find bg-light">
    
    <div className="containerFullWidth page_search" role="main">
   
       <div id="userlist" className="row no-gutters ">
            
            {context.fluxId != "0000" && (
                <div className="utentiDisponibili"><Lang w={"donne_disponibili"} page={"find"}/> <br/>
                    <span onClick={()=>{showPopupHook()}} className="redUnderlined">{context.searchRegion} {context.searchCity && (" - " + context.searchCity)}</span> 
                </div>
            )}
                


			<PhotoItem {...user}/>

       </div>
       
        <div className="row no-gutters">
            <div className="col-12 text-center pb-3 pt-3">
                <div id="loader_pagination"><i className="fas fa-circle-notch fa-spin"></i></div>
            </div>
        </div>
    </div>

   
</div>):(
    <Spinner/>
)}
    

</>);


}

